export default "__VITE_ASSET__CG_AKF5Y__"